module.exports = __webpack_public_path__ + "img/code.b127949c.png";